import React from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { useEffect } from "react";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import AddPruefGroup from "./AddPruefGroup";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../../Constants/Pruef_PlanConstants";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import CommonSearchBar from "../../ReusableComponent/CommonSearchBar";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import { Button } from "@mui/material";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ImportComponent from "../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../Actions/ImportAction";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const PruefGroup = (props) => {
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [pruefGroupList, setpruefGroupList] = useState(null);
  const [ResPruefGroupList, setRespruefGroupList] = useState([]);
  const [prufePlanDetails, setPrufePlanDetails] = useState("");
  const updateSelectedConfig = useSelectedConfigActionContext();
  const columns = [
    // { field: "id", headerName: "ID" },
    {
      field: "bezeichnung",
      headerName: localization.pruefGroupName,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importTestgrp,
    subHeaderTitle: localization.importTestgrpTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  //------------------------Get PrufePlan start ----------------------
  function getPruefGroup() {
    setGlobalSpinner(true);
    Pruef_PlanActions.getPruefGroup();
  }
  useEffect(() => {
    getPruefGroup();
    function getPruefGroupSuccess() {
      const res = pruefPlanStores.getPruefGroupList();

      if (res.length > 0) {
        const tableData = res.map((item) => ({
          id: item.id,
          bezeichnung: item.bezeichnung,
        }));
        setRespruefGroupList(tableData);
        setpruefGroupList(tableData);
      } else {
        setRespruefGroupList([]);
        setpruefGroupList([]);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("Test Group");
    }
    function getPruefGroupFailure() {
      const res = pruefPlanStores.getPruefGroupList();
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_PruefGroup_SUCCESS,
      getPruefGroupSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_PruefGroup_FAILURE,
      getPruefGroupFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_PruefGroup_SUCCESS,
        getPruefGroupSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_PruefGroup_FAILURE,
        getPruefGroupFailure,
      );
    };
  }, []);

  //------------------------Get PrufePlan end ----------------------

  //------------------------Add or update PrufePlan start ----------------------
  useEffect(() => {
    function addorUpdatePruefGroupSuccess() {
      const res = pruefPlanStores.getAddorUpdatePruefGroupResult();
      if (res) {
        commonUtils.hideModalPopUp("addPruefGroupModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.pruefGroupEditedSuccessfully
            : localization.pruefGroupAddSuccessfully,
        );
      } else {
        toast.error(res);
      }
      getPruefGroup();
    }

    function addorUpdatePruefGroupFailure() {
      const res = pruefPlanStores.getAddorUpdatePruefGroupResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS,
      addorUpdatePruefGroupSuccess,
    );

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE,
      addorUpdatePruefGroupFailure,
    );

    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS,
        addorUpdatePruefGroupSuccess,
      );

      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE,
        addorUpdatePruefGroupFailure,
      );
    };
  }, []);

  const handleAdd = () => {
    setPrufePlanDetails("");
  };

  function RenderAddPruefGroup() {
    return (
      <>
        <Button
          id="addTestGroup"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addPruefGroup"
        >
          {localization.add}
        </Button>
      </>
    );
  }
  //------------------------Add or update Hersteller end ----------------------

  //------------------------Edit Prufeplane start ----------------------
  // logic
  const handleEdit = (row) => {
    setPrufePlanDetails(row);
  };

  function RenderEditButton(props) {
    const currentPruefgroup = props.currentPruefgroup;
    return (
      <>
        <Button
          id="editTestGroup"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addPruefGroup"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }

  //------------------------Edit Prufeplane end ----------------------

  //------------------------Delete Prufeplane start ----------------------
  useEffect(() => {
    function pruefGroupDeleteSuccess() {
      const res = pruefPlanStores.getDeletePruefGroup();
      if (res && res.length == 0) {
        toast.success(localization.pruefGroupDeletedSuccessfully);
      } else if (res && res.length > 0) {
        res.forEach((item) => toast.error(item));
      }

      getPruefGroup();
    }
    function pruefGroupDeleteFailure() {
      const res = pruefPlanStores.getDeletePruefGroup();
      if (res && res.length == 0) {
        toast.error(res);
      } else if (res && res.length > 0) {
        res.forEach((item) => toast.error(item));
      }
      setGlobalSpinner(false);
    }

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_PruefGroup_SUCCESS,
      pruefGroupDeleteSuccess,
    );

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_PruefGroup_FAILURE,
      pruefGroupDeleteFailure,
    );

    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_PruefGroup_SUCCESS,
        pruefGroupDeleteSuccess,
      );

      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_PruefGroup_FAILURE,
        pruefGroupDeleteFailure,
      );
    };
  }, []);

  function deletePrurfGroupCallback(PrurfGroupIds) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToPruefGroup);
    setCallbackData(PrurfGroupIds);
    setEventType("DELETE_PruefGroup");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_PruefGroup":
          setGlobalSpinner(true);
          const res = Pruef_PlanActions.deletePruefGroup(data);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const closeAddEditPruefGroupPopUpCallback = () => {
    setPrufePlanDetails("");
  };
  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deletePrurfGroupCallback(_idList);
  };
  function RenderDeleteButton() {
    return (
      <>
        <Button
          id="deleteTestGroup"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  //------------------------Delete Prufeplane end ----------------------
  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  function handleSearch(_enterText) {
    const res = customizeFilter(ResPruefGroupList, _enterText, ["id"]);
    setpruefGroupList(res);
  }
  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: handleEdit,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      { label: "Add", component: <RenderAddPruefGroup />, onClick: handleAdd },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };
  function handleImport(seletedFile) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "TestGroup",
      ImportFile: seletedFile,
    };

    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getPruefGroup();
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "TestGroup",
      UpdateTempalte: false,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
        data-toggle="modal"
        data-target="#addPruefGroup"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div
        id="content"
        style={{ height: "100%", width: "100%", overflow: "auto" }}
      >
        {pruefGroupList && (
          <CustomDataGrid
            Title={localization.insSetting + " / " + localization.pruefGroup}
            columns={columns}
            rows={pruefGroupList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["bezeichnung"]}
            showCheckBox={true}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <AddPruefGroup
        prufePlanDetails={prufePlanDetails}
        closeAddEditPruefGroupPopUpCallback={
          closeAddEditPruefGroupPopUpCallback
        }
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default PruefGroup;
